export const truncateText = (text, maxWords) => {
  let truncatedText = text.split(' ').slice(0, maxWords).join(' ');
  if (text.split(' ').length > maxWords) {
    truncatedText = truncatedText + '...';
  }
  return truncatedText;
};
